<template>
    <v-container>
        <v-row class="align-center justify-center my-4">
            <v-col cols="12" xs="12" sm="4" md="4" class="text-center">
                <v-img :src="clientLogo" width="100%" height="120" contain/>
                <h4 class="mt-4">ID: {{verifyId}}</h4>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" class="text-center">
               <h2 class="mb-3">{{clientName}} <br> <span v-if="city">in {{city}}</span></h2>
               <p class='body-2' v-for="orderCategory in uniqueOrderCategories.slice(0,3)" :key="orderCategory.uuid">
                <span v-if="orderCategory.parent">
                  <span v-if="isDe">
                    {{ orderCategory.parent.name }}
                  </span>
                  <span v-else>{{ orderCategory.parent.name_en }} </span>
                </span>
                <span>{{ orderCategory.name}}</span>
               </p>
               <v-dialog v-model="dialog" max-width="1000">
                 <template v-slot:activator="{on, attrs}">
                    <v-btn v-bind="attrs" v-on="on" color="primary" rounded depressed>
                      Details
                    </v-btn>
                 </template>
                 <v-card>
                   <v-card-title>
                     {{ $t('projects') }}
                   </v-card-title>
                   <v-card-text>
                     <v-simple-table>
                       <template v-slot:default>
                         <thead>
                           <tr>
                             <th class="text-left"> {{ $t('project') }}</th>
                             <th class="text-left"> {{ $t('desc') }}</th>
                             <th class="text-left"> {{ $t('emis') }}</th>
                             <th class="text-left"> {{ $t('cat') }}</th>
                             <th class="text-left"> {{ $t('cert') }}</th>
                             <th class="text-left"> {{ $t('created') }}</th>
                           </tr>
                         </thead>
                         <tbody>
                           <tr v-for="orderItem in orderItems" :key="orderItem.uuid">
                             <td>
                                <strong>
                                  <span v-if="isDe">{{ orderItem.project.display_name }}</span>
                                  <span v-else>{{ orderItem.project.display_name_en }}</span>
                                </strong>
                              </td>
                             <td>
                               <span v-if="isDe"> {{ orderItem.project.long_description}}</span>
                               <span v-else>{{ orderItem.project.long_description_en}}</span>
                            </td>
                             <td>{{ orderItem.emissions }} {{ orderItem.emissions_unit }}</td>
                             <td><span v-if="orderItem.order_item_category.parent">
                                <span v-if="isDe">
                                  {{ orderItem.order_item_category.parent.name}}
                                  ({{orderItem.order_item_category.name}})
                                </span>
                                <span v-else>
                                  {{ retrieveEn(orderItem) }}
                                </span>
                              </span>
                              <span v-else>{{ orderItem.order_item_category.name}}</span>
                              </td>
                              <td>
                                <v-btn :href="orderItem.certificate_url" outlined color="primary">
                                  Download
                                </v-btn>
                              </td>
                              <td>
                                {{ orderItem.created_on  | moment("DD.MM.YYYY")}}
                              </td>
                           </tr>
                         </tbody>
                       </template>
                     </v-simple-table>
                   </v-card-text>
                   <v-card-actions>
                      <v-spacer/>
                         <v-btn @click="close" outlined>{{ $t('close_btn') }}</v-btn>

                   </v-card-actions>
                 </v-card>
               </v-dialog>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" class="text-center justify-center">
                <v-img  class="text-center mx-auto" width="60%" contain :src="logoSrc" />
            </v-col>
        </v-row>
    </v-container>
</template>

<i18n>
{
  "en": {
    "projects": "Projects",
    "project": "Project",
    "desc": "Project Description",
    "emis": "Emissions",
    "cat": "Category",
    "cert": "Certificate",
    "created": "Created on",
    "close_btn": "Close"
  },
  "de": {
    "projects": "Projekte",
    "project": "Projekt",
    "desc": "Projekt Beschreibung",
    "emis": "Emissionen",
    "cat": "Kategorie",
    "cert": "Zertifikat",
    "created": "Erstellt",
    "close_btn": "Schliessen"
  }
}
</i18n>

<script>
import climateCompLogo from '@/assets/Klimabeitrag_mit_ConClimate-Logo.png';
import climateCompLogoEn from '@/assets/climate_contribution_with_ConClimate-Logo.png';

export default {
  name: 'CompanyInfo',
  data() {
    return {
      climateCompLogo,
      dialog: false,
    };
  },
  props: {
    verifyId: {
      type: String,
      default: '0',
      required: true,
    },
    clientName: {
      type: String,
      default: '',
      required: true,
    },
    clientLogo: {
      type: String,
      default: 'https://',
      required: true,
    },
    city: {
      type: String,
      default: '',
      required: true,
    },
    orderItems: {
      type: Array,
      required: true,
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    retrieveEn(orderItem) {
      return orderItem.order_item_category.name_en;
    },
  },
  computed: {
    isDe() {
      if (this.$i18n.locale === 'en') {
        return false;
      }
      return true;
    },
    logoSrc() {
      if (this.$i18n.locale === 'en') {
        return climateCompLogoEn;
      }
      return climateCompLogo;
    },
    uniqueOrderCategories() {
      const orderItemCategories = [];
      this.orderItems.forEach((orderItem) => {
        orderItemCategories.push(orderItem.order_item_category);
      });

      const uniqueOrderItemCategories = orderItemCategories.filter((v, i, a) => a.findIndex((t) => (t.uuid === v.uuid)) === i);

      return uniqueOrderItemCategories;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
